import { render, staticRenderFns } from "./updatePwd.vue?vue&type=template&id=fa3596c2&scoped=true&"
import script from "./updatePwd.vue?vue&type=script&lang=js&"
export * from "./updatePwd.vue?vue&type=script&lang=js&"
import style0 from "./updatePwd.vue?vue&type=style&index=0&id=fa3596c2&scoped=true&lang=scss&"
import style1 from "./updatePwd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3596c2",
  null
  
)

export default component.exports